import { useState, useEffect, useRef, useMemo } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/Table";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import SummaryCard from "../../Components/Tenants/SummaryCard";
import { MdClose } from "react-icons/md";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import NotFoundModel from "../../Components/NotFoundModel";
import { IoFilter } from "react-icons/io5";
import FilterModal from "../../Components/Tenants/FilterModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import SideModal from "../../Components/SideModal";
import SelectProperty from "../../Components/AddTenant/SelectProperty";
import Notes from "../../Components/Tenants/Notes";
import moment from "moment";
import TenantDetailsModal from "../../Components/Tenants/TenantDetailsModal";
import PaymentLinkModal from "../../Components/PaymentLinkModal";
import usePaymentReminder from "../../utilities/usePaymentReminder";
import useTenantDetailsModal from "../../utilities/useTenantDetailsModal";
import RemainderAll from "../../Components/Dues/RemainderAll";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const Tenants = () => {
  const locationState = useLocation();
  const navState = locationState.state || {};
  const user = useSelector((state) => state.UserReducer.user);
  const [hasError, setHasError] = useState(false);

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty,
  );
  const location = useSelector(
    (state) => state.SelectLocationReducer.selectLocation
  );
  const [isRemainderAll, setIsRemainderAll] = useState(false);

  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  //const [addTenant, setAddTenant] = useState(false);
  const [isSelectProperty, setIsSelectProperty] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  // const [filter, setFilter] = useState(user?.defaultTenantFilter || "");

  const [filter, setFilter] = useState(
    navState?.filter ?? user?.defaultTenantFilter ?? ""
  );

  const [filterVal, setFilterVal] = useState("");

  const TENANT_TIME_SCOPE = {
    THIS_MONTH: "THIS_MONTH",
    NEXT_MONTH: "NEXT_MONTH",
    ALL: "ALL",
  };

  const [movingOutScope, setMovingOutScope] = useState(TENANT_TIME_SCOPE.ALL);

  const [reserveScope, setReserverScope] = useState(TENANT_TIME_SCOPE.ALL);

  const ACTIVE_TENANT_SCOPE = {
    THIS_MONTH: "THIS_MONTH",
    ALL: "ALL",
  };

  const [activeTenantScope, setActiveTenantScope] = useState(
    ACTIVE_TENANT_SCOPE.ALL,
  );

  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
    subTitle: "",
  });

  const [apiData, setApiData] = useState();
  const [staffData, setStaffData] = useState([]);
  const [summaryData, setSummaryData] = useState({
    totalTenants: 0,
    newTenants: 0,
    verified: 0,
    moveIn: 0,
    moveOut: 0,
    unVerified: 0,
    appNotInstalled: 0,
  });

  const [filterSource, setFilterSource] = useState(null);
  const [summarySelectedKey, setSummarySelectedKey] = useState(null);
  // const [selectedProperty, setSelectedProperty] = useState(property);
  const [selectedProperty, setSelectedProperty] = useState(() => {
    if (navState?.propId !== undefined && navState?.propId !== null) {
      const id = Number(navState.propId);
      const matched = properties?.find((p) => p.id === id);
      return matched ?? { id };
    }
    return property;
  });
  const [isViewNotes, setIsViewNotes] = useState(false);

  const query = `propId=${selectedProperty?.id}&searchVal=&filter=${filter}&filterVal=${filterVal}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };
  const getSuccess = (res) => {
    if (res?.data === false) {
      setHasError(true);
      setApiData([]);
      setSummaryData({});
      setStaffData([]);
      return;
    }
    setHasError(false);
    setApiData(res?.data?.list ?? []);
    setSummaryData(res?.data?.summary ?? {});
    setStaffData(res?.staffList ?? []);
    setIsFocused(true);
  };

  const getError = (error) => {
    toast.error(
      error?.response?.data?.msg ||
      "Unable to load tenants. Please try again."
    );
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const isError = error || hasError

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
    return () => clearTimeout(handler);
  }, [filter, filterVal, selectedProperty, getListMutate]);

  const filteredApiData = useMemo(() => {
    // If not Moving Out, do nothing
    if ((filter !== "M" && filter !== "" && filter !== "R") || !apiData) {
      return apiData || [];
    }

    const now = moment();

    const startOfThisMonth = now.clone().startOf("month");
    const endOfThisMonth = now.clone().endOf("month");

    const startOfNextMonth = now.clone().add(1, "month").startOf("month");
    const endOfNextMonth = now.clone().add(1, "month").endOf("month");

    if (filter === "M") {
      return apiData.filter((item) => {
        if (!item.moveOutDate) return false;

        const moveOut = moment(item.moveOutDate);

        if (movingOutScope === "THIS_MONTH") {
          sessionStorage.removeItem("tenant_active_page");
          return moveOut.isBetween(
            startOfThisMonth,
            endOfThisMonth,
            undefined,
            "[]",
          );
        }

        if (movingOutScope === "NEXT_MONTH") {
          sessionStorage.removeItem("tenant_active_page");
          return moveOut.isBetween(
            startOfNextMonth,
            endOfNextMonth,
            undefined,
            "[]",
          );
        }

        // ALL
        return true;
      });
    } else if (filter === "R") {
      return apiData.filter((item) => {
        if (!item.moveInDate) return false;

        const moveIn = moment(item.moveInDate);

        if (reserveScope === "THIS_MONTH") {
          sessionStorage.removeItem("tenant_active_page");
          return moveIn.isBetween(
            startOfThisMonth,
            endOfThisMonth,
            undefined,
            "[]",
          );
        }

        if (reserveScope === "NEXT_MONTH") {
          sessionStorage.removeItem("tenant_active_page");
          return moveIn.isBetween(
            startOfNextMonth,
            endOfNextMonth,
            undefined,
            "[]",
          );
        }

        // ALL
        return true;
      });
    } else {
      return apiData.filter((item) => {
        if (!item.moveInDate) return false;

        const moveIn = moment(item.moveInDate);

        if (activeTenantScope === "THIS_MONTH") {
          sessionStorage.removeItem("tenant_active_page");
          return moveIn.isBetween(
            startOfThisMonth,
            endOfThisMonth,
            undefined,
            "[]",
          );
        }

        // ALL
        return true;
      });
    }
  }, [apiData, filter, movingOutScope, activeTenantScope, reserveScope]);

  const tenants = filteredApiData || [];

  const tenantCounts = useMemo(() => {
    if ((filter !== "M" && filter !== "" && filter !== "R") || !apiData) {
      return { thisMonth: 0, nextMonth: 0, all: 0 };
    }

    const now = moment();
    if ("M" === filter) {
      return {
        thisMonth: apiData.filter((item) =>
          item.moveOutDate &&
          moment(item.moveOutDate).isValid() &&
          moment(item.moveOutDate).isSame(now, "month"),
        ).length,

        nextMonth: apiData.filter((item) =>
          item.moveOutDate &&
          moment(item.moveOutDate).isValid() &&
          moment(item.moveOutDate).isSame(now.clone().add(1, "month"), "month"),
        ).length,

        all: apiData.length,
      };
    } else if ("R" === filter) {
      return {
        thisMonth: apiData.filter((item) =>
          item.moveInDate &&
          moment(item.moveInDate).isValid() &&
          moment(item.moveInDate).isSame(now, "month"),
        ).length,

        nextMonth: apiData.filter((item) =>
          item.moveInDate &&
          moment(item.moveInDate).isValid() &&
          moment(item.moveInDate).isSame(now.clone().add(1, "month"), "month"),
        ).length,

        all: apiData.length,
      };
    } else {
      return {
        thisMonth: apiData.filter((item) =>
          item.moveInDate &&
          moment(item.moveInDate).isValid() &&
          moment(item.moveInDate).isSame(now, "month"),
        ).length,

        all: apiData.length,
      };
    }
  }, [apiData, filter]);

  useEffect(() => {
    if (property && !selectedProperty) {
      setSelectedProperty(property);
    }
  }, [property, selectedProperty]);

  useEffect(() => {
    if (location?.id) {
      sessionStorage.removeItem("tenant_active_page");

      setFilter("L");
      setFilterVal(location.id);

      setActiveFilter({
        value: "L",
        filterVal: location.id,
        label: location.name || "Location",
        title: "Location",
        subTitle: "Location",
      });

      setSelectedProperty({
        id: 0,
        name: "All Properties",
        gId: "KIPINN",
        type: 0,
        tenantPreference: 3,
        tenantCount: 0,
      });
    }
  }, [location]);


  const handlePropertySelect = (property) => {
    sessionStorage.removeItem("tenant_active_page");
    if (filter === "L") {
      setFilter(user?.defaultTenantFilter ?? "");
      setFilterVal("");
      setActiveFilter({
        value: "",
        filterVal: "",
        label: "",
        title: "",
        subTitle: "",
      });
    }
    setSelectedProperty(property);
  };

  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIsFilterOpen(false);
    };
    const onClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [isFilterOpen]);

  const onApplyFilter = (
    value,
    label,
    title,
    subTitle,
    isBookedBy = false,
    extraValue = null,
  ) => {
    sessionStorage.removeItem("tenant_active_page");
    setFilterSource("dropdown");
    setSummarySelectedKey(null);

    if (isBookedBy) {
      setFilter("BY");
      setFilterVal(extraValue ? extraValue.join(",") : "");
      setActiveFilter({
        value: extraValue ? extraValue.join(",") : "",
        filterVal: extraValue ? extraValue.join(",") : "",
        label,
        title,
        subTitle,
      });
    } else if (value === "L") {
      setFilter("L");
      setFilterVal(extraValue ? extraValue : "");
      setActiveFilter({
        value: "L",
        filterVal: extraValue ? extraValue : "",
        label,
        title,
        subTitle,
      }); setSelectedProperty({ id: 0, name: "All Properties", gId: "KIPINN", type: 0, tenantCount: 634, tenantPreference: 3, type: 0 });

    } else {
      setFilter(value);
      setFilterVal("");
      setActiveFilter({
        value,
        filterVal: "",
        label,
        title,
        subTitle,
      });
    }

    setIsFilterOpen(false);
  };

  const onSummaryBoxClick = (value) => {
    sessionStorage.removeItem("tenant_active_page");
    setFilterSource("summary");
    setSummarySelectedKey(value);
    if (value === "") {
      setFilter(user?.defaultTenantFilter || "");
    } else {
      setFilter(value);
    }
    setFilterVal("");
    setActiveFilter({ value: "", filterVal: "", label: "", title: "", subTitle: "" });
    setIsFilterOpen(false);
  };

  const clearFilter = () => {
    //setFilter("");
    setFilter(user?.defaultTenantFilter || "");
    setFilterVal("");
    setActiveFilter({
      value: "",
      filterVal: "",
      label: "",
      title: "",
      subTitle: "",
    });
    setFilterSource(null);
    setSummarySelectedKey(null);
    setIsFilterOpen(false);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  const handleSelectPropertyClose = () => {
    setIsSelectProperty(false);
  };


  const {
    selectedTenant,
    showTenantModal,
    openTenantModal,
    closeTenantModal,
    handleNext,
    handlePrevious,
    hasNext,
    hasPrevious,
    isLoading: isTenantDetailsLoading
  } = useTenantDetailsModal({
    tenants: tenants || [],
    token: user.token,
  });

  const {
    loadingId,
    paymentData,
    showPaymentLinkModal,
    loadPaymentLinkModal,
    closePaymentModal,
  } = usePaymentReminder(user.token);


  const {
    isLoading: sendReminderLoading,
    mutate: sendReminderMutate,
  } = useMutation(
    async ({ tenantId }) => {
      return axios.post(
        `${Config.apiUrl}/client/send-reminder`,
        {
          toUserType: Config.USER_TYPE.TENANT,
          broadcastType: 1
        },
        {
          headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        }
      );
    },
    {
      onSuccess: ({ data }) => {
        if (data?.isSuccess) {
          toast.success(data?.msg || "Success");
          setIsRemainderAll(false);
        } else {
          toast.error(data?.msg || "An Error Occurred");
        }

        setSelectedData("");
      },

      onError: (error) => {
        setSelectedData("");
        toast.error(error?.response?.data?.msg || "An Error Occurred");
      },
    }
  );

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            {"Tenants"}
            <Underline />
          </BoxTitle>
          <div className="flex space-x-4 md:ml-auto">
            {data?.data?.isEkycBulkEnabled === 1 && filter === "UV" && (
              <AddBtn
                type="button"
                onClick={() => {
                  setIsRemainderAll(true);
                }}
              >
                {"eKYC Reminder"}
              </AddBtn>
            )}
            <ApplyBtn
              type="button"
              onClick={() => {
                setIsSelectProperty(true);
              }}
            >
              {"Add Tenant"}
            </ApplyBtn>
          </div>
        </BoxHead>

        <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
          <FilterModal
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            staffData={staffData}
            currentFilter={filter}
            handleClearFilters={clearFilter}
            currentFilterVal={filterVal}
            setSelectedLocationId={setSelectedLocationId}
            selectedLocationId={selectedLocationId}
          />
        </SideModal>

        <PaymentLinkModal
          isOpen={showPaymentLinkModal}
          onClose={closePaymentModal}
          paymentData={paymentData}
        />

        {showTenantModal && (
          <SideModal
            isOpen={showTenantModal}
            onClose={closeTenantModal}
          >
            <TenantDetailsModal
              isLoading={isTenantDetailsLoading}
              tenant={selectedTenant}
              onClose={closeTenantModal}
              onNext={handleNext}
              onPrevious={handlePrevious}
              hasNext={hasNext}
              hasPrevious={hasPrevious}
              loadPaymentLinkModal={
                loadPaymentLinkModal
              }
              loadingId={loadingId}
            />
          </SideModal>
        )}

        {/* <div
          className={`${addTenant ? "flex" : "hidden"
            } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out`}
        />
        <div
          className={`${addTenant ? "translate-x-0" : "translate-x-full"
            } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {addTenant && (
            <AddTenantPage setAddTenant={setAddTenant} addTenant={addTenant} />
          )}
        </div> */}
        <SideModal
          isOpen={isSelectProperty}
          onClose={() => setIsSelectProperty(false)}
        >
          <SelectProperty
            setIsSelectProperty={setIsSelectProperty}
            isSelectProperty={isSelectProperty}
            handleClose={handleSelectPropertyClose}
            getListMutate={getListMutate}
          />
        </SideModal>
        <SideModal isOpen={isViewNotes} onClose={() => setIsViewNotes(false)}>
          <Notes
            isViewNotes={isViewNotes}
            setIsViewNotes={setIsViewNotes}
            selectedData={selectedData}
          />
        </SideModal>
        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={5} />
        )}

        {!isError && isFocused && summaryData && (
          <SummaryCard
            summaryData={summaryData}
            onClick={onSummaryBoxClick}
            selectedKey={summarySelectedKey}
          />
        )}
        {!isError && !isLoading && apiData && (
          <FilterTableWrapper>
            <FilterWrapper>
              {isFocused && data && (
                <>
                  <div className="flex items-center justify-between w-full gap-3">
                    {/* LEFT: Moving Out Scope Toggle */}
                    {filter === "M" && (
                      <div className="flex items-center gap-3">
                        <div className="flex items-center bg-slate-100 rounded-xl p-1">
                          <SegmentButton
                            active={
                              movingOutScope === TENANT_TIME_SCOPE.THIS_MONTH
                            }
                            count={tenantCounts?.thisMonth}
                            onClick={() =>
                              setMovingOutScope(TENANT_TIME_SCOPE.THIS_MONTH)
                            }
                          >
                            This Month
                          </SegmentButton>

                          <SegmentButton
                            active={
                              movingOutScope === TENANT_TIME_SCOPE.NEXT_MONTH
                            }
                            count={tenantCounts?.nextMonth}
                            onClick={() =>
                              setMovingOutScope(TENANT_TIME_SCOPE.NEXT_MONTH)
                            }
                          >
                            Next Month
                          </SegmentButton>

                          <SegmentButton
                            active={movingOutScope === TENANT_TIME_SCOPE.ALL}
                            count={tenantCounts?.all}
                            onClick={() =>
                              setMovingOutScope(TENANT_TIME_SCOPE.ALL)
                            }
                          >
                            All
                          </SegmentButton>
                        </div>
                      </div>
                    )}
                    {/* LEFT: Reserve Scope Toggle */}
                    {filter === "R" && (
                      <div className="flex items-center gap-3">
                        <div className="flex items-center bg-slate-100 rounded-xl p-1">
                          <SegmentButton
                            active={
                              reserveScope === TENANT_TIME_SCOPE.THIS_MONTH
                            }
                            count={tenantCounts?.thisMonth}
                            onClick={() =>
                              setReserverScope(TENANT_TIME_SCOPE.THIS_MONTH)
                            }
                          >
                            This Month
                          </SegmentButton>

                          <SegmentButton
                            active={
                              reserveScope === TENANT_TIME_SCOPE.NEXT_MONTH
                            }
                            count={tenantCounts?.nextMonth}
                            onClick={() =>
                              setReserverScope(TENANT_TIME_SCOPE.NEXT_MONTH)
                            }
                          >
                            Next Month
                          </SegmentButton>

                          <SegmentButton
                            active={reserveScope === TENANT_TIME_SCOPE.ALL}
                            count={tenantCounts?.all}
                            onClick={() =>
                              setReserverScope(TENANT_TIME_SCOPE.ALL)
                            }
                          >
                            All
                          </SegmentButton>
                        </div>
                      </div>
                    )}
                    {/* LEFT: Active Tenants Scope Toggle */}
                    {filter === "" && (
                      <div className="flex items-center gap-3">
                        <div className="flex items-center bg-slate-100 rounded-xl p-1">
                          <SegmentButton
                            active={
                              activeTenantScope ===
                              ACTIVE_TENANT_SCOPE.THIS_MONTH
                            }
                            count={tenantCounts?.thisMonth}
                            onClick={() =>
                              setActiveTenantScope(
                                ACTIVE_TENANT_SCOPE.THIS_MONTH,
                              )
                            }
                          >
                            This Month
                          </SegmentButton>

                          <SegmentButton
                            active={
                              activeTenantScope === ACTIVE_TENANT_SCOPE.ALL
                            }
                            count={tenantCounts?.all}
                            onClick={() =>
                              setActiveTenantScope(ACTIVE_TENANT_SCOPE.ALL)
                            }
                          >
                            All
                          </SegmentButton>
                        </div>
                      </div>
                    )}

                    <div className="flex gap-2 justify-end items-center ml-auto">
                      <PropertiesFilterDropdown
                        properties={properties}
                        selectedProperty={selectedProperty}
                        onPropertySelect={handlePropertySelect}
                        placeholder="Select Property"
                        className="min-w-[200px] w-full md:w-[220px]"
                      />
                      {activeFilter.value && !isLoading && data ? (
                        // <div className="hidden md:inline-flex flex-col items-center gap-1 rounded-md border border-neutral-300 bg-neutral-50 px-4 h-10 justify-center text-sm">
                        //   <div className="flex items-center gap-2">
                        //     {/* <span className="text-neutral-500 text-sm">
                        //       {activeFilter.subTitle ? `${activeFilter.subTitle} : ` : ""}{" "}
                        //       {activeFilter.label}
                        //     </span> */}
                        //     <span className="text-neutral-500 text-sm">
                        //       {activeFilter.title === "Booked By"
                        //         ? `${activeFilter.title}: ${activeFilter.label}`
                        //         : `${activeFilter.subTitle ? activeFilter.subTitle + " : " : ""}${activeFilter.label}`}
                        //     </span>

                        //     <div className="bg-gray-100 px-2 rounded-lg">
                        //       <span className="text-sm font-semibold text-neutral-700">
                        //         {data?.data?.total}
                        //       </span>
                        //     </div>
                        //     <button
                        //       aria-label="Clear filter"
                        //       className="ml-1 rounded-full p-1 hover:bg-neutral-200"
                        //       onClick={clearFilter}
                        //     >
                        //       <MdClose size={14} />
                        //     </button>
                        //   </div>
                        // </div>
                        <div
                          className="hidden md:inline-flex items-center gap-2 rounded-md 
                            bg-slate-100 px-3 h-9 text-sm text-slate-600"
                        >
                          <span className="truncate max-w-[180px]">
                            {activeFilter.title === "Booked By"
                              ? `${activeFilter.title}: ${activeFilter.label}`
                              : `${activeFilter.subTitle ? activeFilter.subTitle + " : " : ""}${activeFilter.label}`}
                          </span>

                          <span
                            className="bg-white border border-slate-200 
                              text-slate-800 px-2 py-0.5 rounded-full text-xs font-semibold"
                          >
                            {data?.data?.total}
                          </span>

                          <button
                            aria-label="Clear filter"
                            className="rounded-full p-1 hover:bg-slate-200 transition"
                            onClick={clearFilter}
                          >
                            <MdClose size={14} />
                          </button>
                        </div>
                      ) : null}
                      <div className="relative">
                        {/* {isFocused && data && ( */}
                        <FilterBtn
                          ref={btnRef}
                          type="button"
                          title="Tenant Filter"
                          onClick={() => setIsFilterOpen((v) => !v)}
                        >
                          <IoFilter size={14} color="#9CA3AF" />
                        </FilterBtn>
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </FilterWrapper>
            <TableWrapper>
              <Table
                //apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                apiData={isError ? [] : filteredApiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                isMovingOut={filter}
                setIsViewNotes={setIsViewNotes}
                handleOpenTenantModal={openTenantModal}
              />
              {(isError || filteredApiData?.length === 0) && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          </FilterTableWrapper>
        )}

        {(isLoading || isRefetching) && <Loading />}

        {isError && !isLoading && <NotFoundModel />}

        {isRemainderAll && (
          <RemainderAll
            sendReminderMutate={sendReminderMutate}
            sendReminderLoading={sendReminderLoading}
            setIsRemainderAll={setIsRemainderAll}
            title={"This will send an eKYC reminder to all tenants with pending eKYC."}
          />
        )}
      </BoxContainer>
    </>
  );
};

const SegmentButton = ({ active, count, children, ...props }) => (
  <button
    {...props}
    className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-[transform,box-shadow] duration-150 ease-out
      ${active
        ? "bg-white text-slate-900 shadow-sm scale-[1.02]"
        : "text-slate-600 hover:text-slate-800 hover:scale-[1.01]"
      }`}
  >
    <span>{children}</span>

    {typeof count === "number" && (
      <span
        className={`min-w-[20px] h-5 px-2 rounded-full text-xs flex items-center justify-center
          ${active ? "bg-blue-100 text-blue-700" : "bg-slate-200 text-slate-600"
          }`}
      >
        {count}
      </span>
    )}
  </button>
);

const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm ml-auto`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;

export default Tenants;
